import {Component}        from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

// The translations are hardcoded because the i18n files live on S3.
const TEXTS: Record<string, string> = {
    nl: 'Striive is nu powered by Vertage. Dezelfde expertise in talent, versterkt door AI, om te bouwen aan de oplossingen van morgen.',
    en: 'Striive is now powered by Vertage. The same expert talent, amplified by AI, building what comes next.',
};

// Site-wide announcement below the menu, styled like `app-banner`.
// Hidden until the Vertage cut-over, see the inline script in index.html and styles.scss.
@Component({
    selector   : 'app-vertage-announcement',
    standalone : true,
    templateUrl: './vertage-announcement.component.html',
})
export class VertageAnnouncementComponent {
    constructor(private readonly translateService: TranslateService) {
    }

    get text() {
        return TEXTS[this.translateService.currentLang] ?? TEXTS['nl'];
    }
}
